import styled from 'styled-components';

export const KeypointsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 10px 5%; /* Increased side padding from 6% to 10% */
  background-color: aliceblue;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    padding: 16px 5%; /* Responsive padding for smaller screens */
  }
`;

export const AcceptAllButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
`;

export const StatsBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

export const StatsContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
`;
